import { z } from 'zod'
/** expireList Schema */
export const expireListSchema = z.object({
  /** 即將到期點數 */
  point: z.number(),
  /** 即將到期日 */
  expireDate: z.string()
})
export const managerBenefitGetCorporatePointSchema = z.object({
  /** 點數 */
  point: z.number(),
  /** 即將到期點數清單	固定回傳距當下最近之3筆點數資料 */
  expireList: z.array(expireListSchema)
})

export interface ManagerBenefitGetCorporatePoint
  extends z.infer<typeof managerBenefitGetCorporatePointSchema> {}
